import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../../../environment/environment";
import { map } from "rxjs";

@Injectable({ providedIn: 'root' })
export class AdminService {

    private apiBase = `${environment.apiBase}`; 
    private http = inject(HttpClient)

    allClinics = () => 
        this.http.get<any>(`${this.apiBase}/clinics`).pipe(map(
            (response: any) => response.result
        ))
    
    activateClinic = (clinic_id: number) =>
        this.http.put<any>(`${this.apiBase}/clinic/${clinic_id}/activate`, {}).pipe()

    all = () => 
        this.http.get<any>(`${this.apiBase}/providers`).pipe()

    getCurrentAdmin = () =>
        this.http.get<any>(`${this.apiBase}/admins/me`).pipe()

    getAdminNotes = (admin_id: number) =>
        this.http.get<any>(`${this.apiBase}/admins/${admin_id}/notes`).pipe()

    addAdminNote = (admin_id: number, dto: any) =>
        this.http.post<any>(`${this.apiBase}/admins/${admin_id}/notes`, dto).pipe()

    deleteAdminNote = (admin_id: number, note_id: number) =>
        this.http.delete<any>(`${this.apiBase}/admins/${admin_id}/notes/${note_id}`).pipe()
}
